import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PlatformAccessDeclaration() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={20} />
          Vissza a főoldalra
        </button>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">PLATFORM-HOZZÁFÉRÉSI HOZZÁJÁRULÓ NYILATKOZAT</h1>
          <p className="text-sm text-gray-500 mb-8">Hatályos: 2026.01.24. napjától</p>

          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. A NYILATKOZAT CÉLJA</h2>
              <p className="text-gray-700">
                Jelen Platform-hozzáférési hozzájáruló nyilatkozat célja, hogy a Felhasználó kifejezett, önkéntes és egyértelmű hozzájárulását adja ahhoz, hogy a Szolgáltató a Felhasználó nevében, technikai közvetítőként eljárjon a Felhasználó által összekapcsolt közösségi média platformokon.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. ÉRINTETT PLATFORMOK</h2>
              <p className="text-gray-700 mb-4">A Felhasználó hozzájárulása kiterjed az alábbi, harmadik fél által üzemeltetett szolgáltatásokra:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Facebook (Meta Platforms)</li>
                <li>TikTok</li>
                <li>YouTube (Google)</li>
              </ul>
              <p className="text-gray-700">
                A felsorolt platformok saját felhasználási feltételekkel és adatkezelési szabályzatokkal rendelkeznek, amelyekért a Szolgáltató nem vállal felelősséget.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. A HOZZÁJÁRULÁS TARTALMA</h2>
              <p className="text-gray-700 mb-4">A Felhasználó kijelenti és elfogadja, hogy a Szolgáltató jogosult:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>a Felhasználó nevében eljárni;</li>
                <li>a Felhasználó által összekapcsolt fiókokhoz technikai hozzáférést használni;</li>
                <li>videót feltölteni, továbbítani és publikálni a kiválasztott platformokon;</li>
                <li>a publikálási beállításokat a Felhasználó utasításai szerint alkalmazni;</li>
                <li>a feltöltéshez szükséges API-hozzáféréseket kezelni.</li>
              </ul>
              <p className="text-gray-700">
                A Szolgáltató nem jogosult a Felhasználó nevében önálló tartalmat létrehozni vagy módosítani.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. MEGHATALMAZÁS JOGI JELLEGE</h2>
              <p className="text-gray-700 mb-4">
                A Felhasználó jelen nyilatkozattal meghatalmazást ad a Szolgáltatónak arra, hogy kizárólag a Szolgáltatás rendeltetésszerű működéséhez szükséges mértékben eljárjon.
              </p>
              <p className="text-gray-700 mb-2">A meghatalmazás:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>nem kizárólagos,</li>
                <li>nem átruházható,</li>
                <li>időben korlátozott,</li>
                <li>bármikor visszavonható.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. FELELŐSSÉGKIZÁRÁS</h2>
              <p className="text-gray-700 mb-4">A Felhasználó tudomásul veszi, hogy:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>a Szolgáltató nem garantálja a platformok általi elfogadást vagy megjelenítést;</li>
                <li>a platformok jogosultak a tartalom korlátozására, eltávolítására vagy a fiók felfüggesztésére;</li>
                <li>a Szolgáltató nem felel az algoritmikus elérésekért, tiltásokért, árnyéktiltásokért vagy API-változásokért.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. KÉRT JOGOSULTSÁGOK (PERMISSIONS)</h2>
              <p className="text-gray-700 mb-4">A Szolgáltatás működéséhez az alábbi API-jogosultságokat kéri a platformoktól:</p>
              <p className="text-gray-700 mb-2"><strong>Facebook / Meta:</strong></p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>publish_video – videó feltöltése és publikálása</li>
                <li>manage_pages – oldal kezelése, ahová a tartalom kerül</li>
              </ul>
              <p className="text-gray-700 mb-2"><strong>TikTok:</strong></p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>video.publish – videó feltöltése és publikálása</li>
              </ul>
              <p className="text-gray-700 mb-2"><strong>YouTube / Google:</strong></p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>youtube.upload – videó feltöltése a csatornára</li>
              </ul>
              <p className="text-gray-700">
                A Szolgáltató kizárólag a fenti jogosultságokat kéri, és nem fér hozzá egyéb adatokhoz (üzenetek, ismerősök, stb.).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. TOKEN TÁROLÁS ÉS BIZTONSÁG</h2>
              <p className="text-gray-700 mb-4"><strong>7.1.</strong> A platformoktól kapott hozzáférési tokeneket a Szolgáltató biztonságos módon tárolja:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Tárolás helye: Supabase szerver (Stockholm, Svédország – EU)</li>
                <li>Titkosítás: a tokenek titkosítva kerülnek tárolásra</li>
                <li>Hozzáférés: kizárólag a Szolgáltatás automatikus folyamatai férnek hozzá a tokenekhez</li>
              </ul>
              <p className="text-gray-700"><strong>7.2.</strong> A tokenek kizárólag a videófeltöltés technikai lebonyolításához kerülnek felhasználásra.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. TOKEN LEJÁRAT ÉS MEGÚJÍTÁS</h2>
              <p className="text-gray-700 mb-2"><strong>8.1.</strong> A platformok által kiadott tokenek időben korlátozottak.</p>
              <p className="text-gray-700 mb-4"><strong>8.2.</strong> Token lejárat kezelése:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Refresh token esetén: a Szolgáltatás automatikusan megújítja a hozzáférést, külön felhasználói beavatkozás nélkül</li>
                <li>Refresh token nélkül: a lejárt token automatikusan törlődik a rendszerből</li>
              </ul>
              <p className="text-gray-700 mb-4"><strong>8.3.</strong> Érvénytelen token esetén:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Ha a platform visszavonja vagy érvényteleníti a tokent, az automatikusan törlődik</li>
                <li>A Felhasználónak újra össze kell kapcsolnia a fiókját a Szolgáltatásban</li>
              </ul>
              <p className="text-gray-700"><strong>8.4.</strong> A Felhasználó értesítést kap, ha a platform-hozzáférés megújítása szükséges.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. TARTALOMÉRT VALÓ FELELŐSSÉG</h2>
              <p className="text-gray-700 mb-4">A Felhasználó kijelenti, hogy:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>jogosult a feltöltött videók felhasználására;</li>
                <li>a tartalom nem sért szerzői jogot, személyiségi jogot vagy jogszabályt;</li>
                <li>a tartalomért a teljes jogi felelősség a Felhasználót terheli.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. HOZZÁJÁRULÁS VISSZAVONÁSA</h2>
              <p className="text-gray-700 mb-4"><strong>10.1.</strong> A Felhasználó jogosult a hozzájárulást bármikor visszavonni:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>a platformok felületén,</li>
                <li>vagy a Szolgáltatás fiókbeállításaiban.</li>
              </ul>
              <p className="text-gray-700"><strong>10.2.</strong> A hozzájárulás visszavonása a Szolgáltatás működésének korlátozását vagy megszűnését eredményezheti.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. KAPCSOLAT AZ ÁSZF-FEL ÉS AZ ADATKEZELÉSI TÁJÉKOZTATÓVAL</h2>
              <p className="text-gray-700">Jelen nyilatkozat az Általános Szerződési Feltételek és az Adatkezelési Tájékoztató elválaszthatatlan részét képezi.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. ELFOGADÁS MÓDJA</h2>
              <p className="text-gray-700 mb-4">A Felhasználó a hozzájárulást az alábbi módokon adja meg:</p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>checkbox kipipálásával,</li>
                <li>„Elfogadom" gomb megnyomásával,</li>
                <li>a platformfiók összekapcsolásával.</li>
              </ul>
              <p className="text-gray-700">
                A hozzájárulás megadása önkéntes, de a Szolgáltatás igénybevételének feltétele.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
